// extracted by mini-css-extract-plugin
module.exports = {"button":"IntegrationConfigs-module__button___3CgVm","cards":"IntegrationConfigs-module__cards___1MHbA","logo":"IntegrationConfigs-module__logo___3CUVb"};